import { createAction, makeActionTrackable } from '@lingoda/core';
import type { Lesson } from './models';

export const addLessons = createAction<Lesson[]>('lesson/ADD_LESSONS');

export const fetchLesson = makeActionTrackable(createAction<number>('lesson/FETCH_LESSON'));

export const updateLesson = makeActionTrackable(createAction<number>('lesson/UPDATE_LESSON'));
